export default __webpack_public_path__ + "static/postit-b3f7658afbcb5770f5b8c079cd10c59b.svg";